<template>
<div>
    <div class="modal-body reservation-modal">
        <div class="row">
            <div class="col-xs-12">
                <h4 class="modal-title">
                    {{ edit.info }}
                </h4>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12" v-if="!edit.disabled">
                <p>{{ $_locale('order number') }}
                    <a v-bind:href="orderLinkUrl(edit.orderId)" target="_blank">
                        {{ edit.orderId }}
                    </a>
                </p>
            </div>
            <div class="col-xs-12" v-if="edit.disabled">
                <div class="form-group">
                    <label>{{ $_locale('reason') }}</label>
                    <div v-html="edit.disableReason"></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12">
                <div class="form-group">
                    <select class="form-control" 
                            v-model="edit.resourceId"
                            @change="onResourceChange">
                        <option v-for="(resource, index) in settings.resources" 
                                v-bind:key="index"
                                v-bind:value="resource.resourceId">
                            {{ resource.resourceName }}
                        </option>
                    </select>
                </div>
            </div>
        </div>
        <div class="row">
            <div :class="[4,5].indexOf(edit.status) > -1 ? ['col-xs-12 col-sm-4'] : ['col-xs-12 col-sm-8']">
                <label>{{ $_locale('date') }}</label>
                <input type="text" class="form-control" ref="dateInput" />
            </div>
            <div class="col-xs-6 col-sm-4">
                <div class="form-group">
                    <label>{{ $_locale('start time') }}</label>
                    <input class="form-control time-picker" 
                           type="time"
                           v-model="edit.startTime" />
                </div>
            </div>
            <div class="col-xs-6 col-sm-4" v-if="[4,5].indexOf(edit.status) > -1">
                <div class="form-group">
                    <label>{{ $_locale('end time') }}</label>
                    <input class="form-control time-picker" 
                           type="time"
                           v-model="edit.endTime" />
                </div>
            </div>
        </div>
        <div class="row" v-if="[4,5].indexOf(edit.status) > -1 && false">
            <div class="col-xs-12">
                <label>{{ $_locale('specify how many slots are removed from tee time') }}</label>
                <input class="form-control" 
                    v-model="edit.resourceQuantity"
                    max="4"
                    min="1"
                    type="number"
                    style="text-align:right;">
            </div>
        </div>
        <div class="row" v-if="!edit.disabled && [2,3].indexOf(edit.status) > -1">
            <div class="col-xs-12">
                <div class="form-group">
                    <div class="input-group">
                        <input class="form-control" 
                          v-model="edit.totalPrice"
                          type="text" 
                          autocomplete="off"
                          style="text-align:right;">
                        <span class="input-group-addon">{{ $_CURRENCY_SYMBOL }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-default pull-left" @click="$emit('cancel')">
            {{ $_locale(activeReservation.placeholder ? 'close' : 'cancel') }}
        </button>
        <button class="btn btn-danger" @click="deactivateReservationTime">{{ $_locale('delete') }}</button>
        <button class="btn btn-success" @click="saveEditedReservation">
            <span>{{ $_locale('save') }}</span>
        </button>
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { durationToBlockCount } from '../common/ReservationService.js'

export default {
    data: () => ({
        edit: {}
    }),
    computed: {
        ...mapGetters({
            adminMode: 'common/adminMode',
            editReservation: 'calendar/editReservation',
            activeReservation: 'calendar/activeReservation',
            orderLinkUrl: 'ecom/orderLinkUrl',
            date: 'reservations/date',
            settings: 'reservations/settings',
            service: 'reservations/service',
            mobile: 'common/mobile',
        }),
    },
    watch: {
        'editReservation.timestamp': {
            handler(val) {
                // why is this commented out?
                //this.$nextTick(() => this.init())
            }
        },
    },
    methods: {
        init() {
            const { block, reservation, orderProductId } = this.editReservation;
            const formatCurrency = this.$_formatCurrency;

            this.edit = {
                info: block.info,
                disabled: !!block.disabled,
                disableReason: block.disableReason,
                orderId: reservation.orderId,
                orderProductId: reservation.orderProductId,
                reservationTimeId: reservation.reservationTimeId,
                resourceId: reservation.resourceId.toString(),
                date: moment(reservation.start),
                startTime: moment(reservation.start).format('HH:mm'),
                endTime: moment(reservation.end).format('HH:mm'),
                totalPrice: formatCurrency(reservation.totalPrice),
                taxRate: reservation.taxRate,
                status: reservation.status,
            }
            
            if ([4,5].indexOf(this.edit.status) > -1) {
                this.edit.resourceQuantity = reservation.resources[0].quantity;
            }
            //console.log('editReservation.orderProductId', this.edit);
            const { daterangepicker } = window.wisenetwork
            const input = this.$refs.dateInput;

            if (this.mobile) {
                input.readOnly = true;
            }
            
            daterangepicker(
                input,
                {
                    locale: { 
                        format: 'dd DD.MM.YYYY',
                        daysOfWeek: _localeDates.dayNamesMin,
                        monthNames: _localeDates.monthNamesShort,
                        firstDay: 1,
                    },
                    opens: 'right',
                    showWeekNumbers: true,
                    singleDatePicker: true,
                    showDropdowns: true,
                    startDate: this.edit.date,
                }, 
                (startDate, endDate) => {
                    this.edit.date = startDate;
                }
            )
        },
        onResourceChange() {
            const resource = this.settings.resources.filter(row => row.resourceId == this.edit.resourceId)[0]
            
            this.edit.resourceName = resource.resourceName;
        },
        toggleActive(name, value) {
            this.visible = value ? name : 'reservation';
        },
        saveEditedReservation() {
            const EcomService = this.$store.getters['ecom/EcomService'];
            const service = this.service;
            const formatCurrency = this.$_formatCurrency;
            const baseDate = moment(this.edit.date).clone();
            var startTime = this.edit.startTime.split(':');
            var dateTimeStart = baseDate.clone();

            dateTimeStart.set({ hour: startTime[0], minute: startTime[1], second: 0, millisecond: 0 });
            
            var dateTimeEnd = dateTimeStart.clone();

            if ([4,5].indexOf(this.edit.status) > -1) {
                var endTime = this.edit.endTime.split(':');

                dateTimeEnd.set({ hour: endTime[0], minute: endTime[1], second: 0, millisecond: 0 })
            } else {
                dateTimeEnd.add(10, 'minutes')
            }

            var quantity = durationToBlockCount(
                dateTimeStart, 
                dateTimeEnd, 
                service.getBlockTotalLength()
            );
            var totalPrice = formatCurrency(this.edit.totalPrice, false);
            var price = totalPrice / quantity;
            var totalPriceTax = quantity * (price - (price / ((this.edit.taxRate / 100)+1)));
            const data = {
                orderId: this.edit.orderId,
                orderProductId: this.edit.orderProductId,
                reservationTimeId: this.edit.reservationTimeId,
                dateTimeStart: dateTimeStart.format('YYYY-MM-DD HH:mm:ss'),
                dateTimeEnd: dateTimeEnd.format('YYYY-MM-DD HH:mm:ss'),
                resourceId: -(-this.edit.resourceId),
                totalPrice,
                totalPriceTax,
                quantity,
                price
            };

            if ([4,5].indexOf(this.edit.status) > -1) {
                data.resourceQuantity = this.edit.resourceQuantity;
            }

            console.log('saveEditedReservation', data)
            
            this.$store.commit('common/setModal', null);
            
            EcomService.editReservationTime(data)
            .then((response) => {
                const data = response.data;

                if (data.success) {
                    this.$store.dispatch('reservations/onDateChange', this.date)

                    this.$_swal({ icon: 'success', title: _locale('reservation saved').ucfirst() })
                } else {
                    this.$_swal({ icon: 'error', title: data.message })
                }
            })
        },
        deactivateReservationTime() {
            const EcomService = this.$store.getters['ecom/EcomService'];
            
            this.$_swal({
                title: _locale('are you sure').ucfirst(),
                text: '',
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'btn-warning',
                confirmButtonText: _locale('yes').ucfirst(),
                cancelButtonText: _locale('no').ucfirst()
            })
            .then((result) => {
                if (result.isConfirmed) {
                    this.$store.commit('common/setModal', null);

                    EcomService.deactivateReservationTime(this.edit.reservationTimeId)
                        .then((response) => {
                            const data = response.data;

                            if (data.success) {
                                this.$store.dispatch('reservations/onDateChange', this.date);
                                
                                this.$_swal({ icon: 'success', title: _locale('deleted').ucfirst() })
                            } else {
                                this.$_swal({ icon: 'error', title: data.message })
                            }
                        })
                }
            })
        },
    },
    mounted() {
        //console.log('editReservation.mounted', Date.now())
        this.$nextTick(() => this.init())
    }
}
</script>